import type { TFunction } from 'react-i18next';
// Import Helpers
import { formatNumber } from 'services/Helpers';
// Import Enums
import { FormatNumberActionEnum, SpentPercentageStatusEnum } from 'enums';
// Import Constants
import { l } from 'constants/common';

export const formatLimit = (num?: number | string, precision = 0) => {
    return formatNumber(num, {
        type: FormatNumberActionEnum.DecimalPrecision,
        precision: precision,
        isClean: true,
    });
};

export const getPercentageStatus = (
    percentage: string,
    warningThresholdPercentage: number,
): SpentPercentageStatusEnum => {
    if (+percentage < warningThresholdPercentage) return SpentPercentageStatusEnum.Low;
    if (+percentage >= warningThresholdPercentage && +percentage <= 100) return SpentPercentageStatusEnum.High;
    return SpentPercentageStatusEnum.Exceeded;
};

export const getPercentageDescription = (
    percentageStatus: SpentPercentageStatusEnum,
    t: TFunction,
    warningThresholdPercentage: number,
) => {
    const percentageText = {
        [SpentPercentageStatusEnum.Low]: `${t(l.Low)} | < ${warningThresholdPercentage}%`,
        [SpentPercentageStatusEnum.High]: `${t(l.High)} | ${t(l.FromPercentageToPercentage, { from: warningThresholdPercentage, to: 100 })}`,
        [SpentPercentageStatusEnum.Exceeded]: `${t(l.Exceeded)} | > 100%`,
    };
    return percentageText[percentageStatus];
};
